;
;
export var DrawStatus;
(function (DrawStatus) {
    DrawStatus["Open"] = "open";
    DrawStatus["Closed"] = "closed";
    DrawStatus["Pending"] = "pending";
    DrawStatus["Verified"] = "verified";
})(DrawStatus || (DrawStatus = {}));
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export var PrizeDistributorTypes;
(function (PrizeDistributorTypes) {
    PrizeDistributorTypes["Credit"] = "credit";
    PrizeDistributorTypes["CreditMultiplier"] = "credit_multiplier";
    PrizeDistributorTypes["Ticket"] = "ticket";
})(PrizeDistributorTypes || (PrizeDistributorTypes = {}));
;
;
;
;
;
;
export var UserRoles;
(function (UserRoles) {
    UserRoles["Finance"] = "finance";
    UserRoles["Notary"] = "notary";
    UserRoles["Manager"] = "manager";
    UserRoles["Viewer"] = "viewer";
})(UserRoles || (UserRoles = {}));
;
var User = (function () {
    function User(props) {
        this.id = props.id;
        this.name = props.name;
        this.email = props.email;
        this.email_verified_at = props.email_verified_at;
        this.role = props.role;
        this.created_at = props.created_at;
        this.updated_at = props.updated_at;
    }
    User.prototype.isFinance = function () {
        return this.role === UserRoles.Finance;
    };
    User.prototype.isNotary = function () {
        return this.role === UserRoles.Notary;
    };
    User.prototype.isManager = function () {
        return this.role === UserRoles.Manager;
    };
    User.prototype.isViewer = function () {
        return this.role === UserRoles.Viewer;
    };
    User.prototype.getLandingPage = function () {
        return this.isFinance() ? '/prize-distributors' : '/dashboard';
    };
    return User;
}());
export { User };
;
